import React from "react";
import { useTranslation } from "react-i18next";
import getLegalLinks from "../helpers/getLegalLinks";

const HRDFooter = () => {
  const { t } = useTranslation();
  const legalLinks = getLegalLinks();

  return (
    <div className="hrd-footer">
      <a
        href={legalLinks.privacyStatement}
        className="hrd-footer-content"
        target="_blank"
        rel="noreferrer"
      >
        {t("customHRD.footer.privacyStatement")}
      </a>

      <a
        href={legalLinks.cookieInformation}
        className="hrd-footer-content"
        target="_blank"
        rel="noreferrer"
      >
        {t("customHRD.footer.cookieInformation")}
      </a>
    </div>
  );
};

export default HRDFooter;